import React from 'react'
import Helmet from 'react-helmet'
import map from 'lodash/map'
import keys from 'lodash/keys'

class ProPublicaHead extends React.Component {
  render() {

    // Remove nulls and replace underscores with dashes
    // @TODO can this be done at the query level somehow?
    let meta = map(this.props.meta, (item) => {
      var newItem = {}
      keys(item).forEach((key) => {
        if (item[key]) newItem[key.replace('_', '-')] = item[key]
      })
      return newItem
    })

    let title = `${this.props.title} | ProPublica`

    return (<Helmet
      title={title}
      meta={meta}
      link={[
        {rel: "icon", href: "https://assets.propublica.org/prod/v3/images/favicon.ico", type: "image/x-icon"}
      ]}
    />)
  }
}

export default ProPublicaHead



// WEBPACK FOOTER //
// ./src/components/includes/ProPublicaHead/index.js